import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { TextLink } from "../TextLink";

import styles from "./TextTeaser.scss";

const Link = forwardRef(({ href, children, ...props }, ref) => (
  <div className={styles.linkWrapper}>
    <TextLink href={href} ref={ref} {...props}>
      {children}
    </TextLink>
  </div>
));

Link.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
};

Link.defaultProps = {
  children: null,
  href: "#",
};

Link.displayName = "TextTeaser.Link";

export default Link;
